import { useEffect, useRef } from 'react';
import { Await, useNavigate } from 'react-router-dom';

const Navigate = ({ to, replace, state }) => {
    const navigate = useNavigate();
    const navigateRef = useRef(navigate);

    useEffect(() => {
        navigateRef.current = navigate;
    }, [navigate]);
    
    useEffect(() => {
        navigateRef.current(to, { replace, state });
    }, [to, replace, state]);
    
    return <Await/>;
};

export default Navigate;